/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

const ContactsTable = ({ contacts, companyURL, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (contacts.loading) {
      return "is Loading";
    }
    if (isEmpty(contacts.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Weight</th>
            <th>Freezed</th>
            <th>Attachment Count</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {contacts.data.map(contact => (
            <tr key={contact.id}>
              <td>{contact.id}</td>
              <td>{contact.title}</td>
              <td>{contact.weight}</td>
              <td>{contact.freezed ? "Yes" : "No"}</td>
              <td>{contact.attachments ? contact.attachments.length : 0}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/contacts/${contact.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(contact.id)}
                    to={`/${companyURL}/contacts/${contact.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default ContactsTable;
